import { ResponseResolver, rest, RestContext, RestRequest } from "msw";
import { ApiCatalog, BASE_PATH } from "@/api";
import { teacherSchoolAffiliationSuccessResponseMock } from "./mutations.test.mock";
import type {
  SchoolAdminAffiliationResponse,
  TeacherSchoolAffiliationResponse,
} from "./mutations.type";

export const createTeacherSchoolAffiliationMutationHandler = ({
  defaultData,
  status,
  teacherUniqueId,
}: {
  defaultData?: TeacherSchoolAffiliationResponse | undefined;
  status?: number;
  teacherUniqueId: string;
}) => {
  const mockedResolver = jest.fn((_req, res, ctx) => {
    return res(
      ctx.json(defaultData || teacherSchoolAffiliationSuccessResponseMock),
      ctx.status(status || 200),
      ctx.delay(100),
    );
  }) as jest.MockedFunction<ResponseResolver<RestRequest, RestContext>>;
  const path = ApiCatalog.teacherSchoolAffiliation.endpoint.replace(
    "[unique_id]",
    teacherUniqueId,
  );
  const post = rest.post(`${BASE_PATH}${path}`, mockedResolver);
  return {
    post,
    mockedResolver,
  };
};

export const createSchoolAdminSchoolAffiliationMutationHandler = ({
  defaultData,
  status,
  schoolAdminUniqueId,
}: {
  defaultData?: SchoolAdminAffiliationResponse | undefined;
  status?: number;
  schoolAdminUniqueId: string;
}) => {
  const mockedResolver = jest.fn((_req, res, ctx) => {
    return res(
      ctx.json(defaultData || teacherSchoolAffiliationSuccessResponseMock),
      ctx.status(status || 200),
      ctx.delay(100),
    );
  }) as jest.MockedFunction<ResponseResolver<RestRequest, RestContext>>;
  const path = ApiCatalog.schoolAdminSchoolAffiliation.endpoint.replace(
    "[unique_id]",
    schoolAdminUniqueId,
  );
  const post = rest.post(`${BASE_PATH}${path}`, mockedResolver);
  return {
    post,
    mockedResolver,
  };
};
